import { create } from "zustand";

interface SelectedFiltersState {
  selectedConditions: number[];
  selectedColors: number[];
  selectedBrands: number[];
  selectedSize: number[];
  selectedPrice: string;
  selectedCategories: number[];
  selectedSubCategories1: number[];
  selectedSubCategories2: number[];
  selectedSubCategories3: number[];
  selectedMaterials: number[];
  setSelectedConditions: (
    ids: number[] | ((prev: number[]) => number[]),
  ) => void;
  setSelectedColors: (ids: number[] | ((prev: number[]) => number[])) => void;
  setSelectedBrands: (ids: number[] | ((prev: number[]) => number[])) => void;
  setSelectedSize: (ids: number[] | ((prev: number[]) => number[])) => void;
  setSelectedMaterials: (
    ids: number[] | ((prev: number[]) => number[]),
  ) => void;
  setSelectedPrice: (id: string) => void;
  setSelectedCategories: (
    ids: number[] | ((prev: number[]) => number[]),
  ) => void;
  setSelectedSubCategories1: (
    ids: number[] | ((prev: number[]) => number[]),
  ) => void;
  setSelectedSubCategories2: (
    ids: number[] | ((prev: number[]) => number[]),
  ) => void;
  setSelectedSubCategories3: (
    ids: number[] | ((prev: number[]) => number[]),
  ) => void;
}

export const useSelectedFilters = create<SelectedFiltersState>((set) => ({
  selectedConditions: [],
  selectedColors: [],
  selectedBrands: [],
  selectedSize: [],
  selectedPrice: "",
  selectedMaterials: [],
  selectedCategories: [],
  selectedSubCategories1: [],
  selectedSubCategories2: [],
  selectedSubCategories3: [],
  setSelectedConditions: (ids) =>
    set((state) => ({
      selectedConditions:
        typeof ids === "function" ? ids(state.selectedConditions) : ids,
    })),
  setSelectedColors: (ids) =>
    set((state) => ({
      selectedColors:
        typeof ids === "function" ? ids(state.selectedColors) : ids,
    })),
  setSelectedBrands: (ids) =>
    set((state) => ({
      selectedBrands:
        typeof ids === "function" ? ids(state.selectedBrands) : ids,
    })),
  setSelectedSize: (ids) =>
    set((state) => ({
      selectedSize: typeof ids === "function" ? ids(state.selectedSize) : ids,
    })),
  setSelectedMaterials: (ids) =>
    set((state) => ({
      selectedMaterials:
        typeof ids === "function" ? ids(state.selectedMaterials) : ids,
    })),
  setSelectedPrice: (id) =>
    set(() => ({
      selectedPrice: id,
    })),
  setSelectedCategories: (ids) =>
    set((state) => ({
      selectedCategories:
        typeof ids === "function" ? ids(state.selectedCategories) : ids,
    })),
  setSelectedSubCategories1: (ids) =>
    set((state) => ({
      selectedSubCategories1:
        typeof ids === "function" ? ids(state.selectedSubCategories1) : ids,
    })),
  setSelectedSubCategories2: (ids) =>
    set((state) => ({
      selectedSubCategories2:
        typeof ids === "function" ? ids(state.selectedSubCategories2) : ids,
    })),
  setSelectedSubCategories3: (ids) =>
    set((state) => ({
      selectedSubCategories3:
        typeof ids === "function" ? ids(state.selectedSubCategories3) : ids,
    })),
}));
